import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export function AppShell() {
  return (
    <div className="min-h-screen flex flex-col bg-paper">
      <Header />
      <main className="flex-1 max-w-5xl w-full mx-auto px-6 py-12 sm:py-14">
        <Outlet />
      </main>
    </div>
  );
}
